// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"b6fa9f3a","503":"20c29b94","634":"3f121de7","656":"81381754","933":"9551e968"}[chunkId] + ".chunk.js";
};